<template>
  <div class="outterBox">
    <!-- 헤더정보 WEB -->
    <div class="web">
      <div class="row" align-v="center">
        <div class="col-6">
          <div class="row header2">
            <div class="col-3 headerTitle" align-v="center">
              <span class="headerText text-nowrap">예약 정보</span>
            </div>
            <div v-if="hasMultiple" class="col-9">
              <button class="addButton2" @click="copyReceiptValues(revConfirm.receiptDetail)">
                <span>필수 정보 일괄 입력</span>
              </button>
            </div>
          </div>
          <div class="row headerTitle">
            <div class="col-12 ml-0 headerDetailText">클릭 시 다른 일정에도 필수 정보가 반영됩니다.</div>
          </div>
        </div>

        <div class="col-6 align-self-center">
          <div class="text-left">
            <b-form-radio-group
              size="sm"
              class="ml-3 d-flex flex-column"
              v-model="revConfirm.receiptDetail._bookedBy"
              @change="bookedByChanged($event, revConfirm.receiptDetail)"
            >
              <b-form-radio v-if="isCompany" value="SelfBook">
                <div class="d-flex justify-content-center">
                  <div class="align-self-top">본인/배우자{{ reservTextJubsuYeyak }}</div>
                  <div class="justify-content-center">
                    <b-form-select
                      style="margin-top: -0.4rem; margin-left: 0.5rem"
                      class="rounded-0 icon-chevron-down"
                      :disabled="revConfirm.receiptDetail._bookedBy !== 'SelfBook'"
                      v-model="revConfirm.receiptDetail._selected_RealUserSelfOrFamily"
                      :options="options_RealUserSelfOrFamily"
                      @change="selected_RealUserSelfOrFamily_Changed($event, revConfirm.receiptDetail)"
                    >
                    </b-form-select>
                  </div>
                </div>
              </b-form-radio>
              <b-form-radio v-if="isCompany" value="Recommender" :disabled="isNotRecomValid"
                >추천인{{ reservTextJubsuYeyak }}</b-form-radio
              >
            </b-form-radio-group>
          </div>
        </div>
      </div>
      <hr />
    </div>

    <!--    <div class="web">-->
    <!--      <div class="row" align-v="center">-->
    <!--        <div class="header2 col-2" align-v="center">-->
    <!--          <div class="headerTitle" align-v="center">-->
    <!--            <span class="headerText">예약 정보</span>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <div v-if="hasMultiple" class="col-3">-->
    <!--          <button class="addButton2" @click="copyReceiptValues(revConfirm.receiptDetail)">-->
    <!--            <span>필수 정보 일괄 입력</span>-->
    <!--          </button>-->
    <!--        </div>-->
    <!--        <div class="header2 col-7">-->
    <!--          <div class="headerTitle">-->
    <!--            <span class="headerDetailText">클릭 시 다른 일정에도 필수 정보가 반영됩니다 </span>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <div class="row">-->
    <!--        <div class="col-12 text-right" align-v="center">-->
    <!--          <b-form-radio-group-->
    <!--            size="sm"-->
    <!--            class="ml-4"-->
    <!--            v-model="revConfirm.receiptDetail._bookedBy"-->
    <!--            @change="bookedByChanged($event, revConfirm.receiptDetail)"-->
    <!--          >-->
    <!--            <b-form-radio v-if="isCompany" value="SelfBook">-->
    <!--              <div class="d-flex justify-content-center">-->
    <!--                <div class="">본인/배우자{{ reservTextJubsuYeyak }}</div>-->
    <!--                <div class="px-2 justify-content-center" style="margin-top: -0.5rem; padding-left: 0.5rem">-->
    <!--                  <b-form-select-->
    <!--                    plain-->
    <!--                    :disabled="revConfirm.receiptDetail._bookedBy !== 'SelfBook'"-->
    <!--                    v-model="revConfirm.receiptDetail._selected_RealUserSelfOrFamily"-->
    <!--                    :options="options_RealUserSelfOrFamily"-->
    <!--                    @change="selected_RealUserSelfOrFamily_Changed($event, revConfirm.receiptDetail)"-->
    <!--                  >-->
    <!--                  </b-form-select>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--            </b-form-radio>-->

    <!--            <b-form-radio v-if="isCompany" value="Recommender">추천인{{ reservTextJubsuYeyak }}</b-form-radio>-->
    <!--          </b-form-radio-group>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->

    <!-- 헤더정보 MOBILE -->
    <div class="mobile">
      <div class="row">
        <div class="col-4 headerTitle">
          <span class="headerText text-nowrap">예약 정보</span>
        </div>
        <div class="col-8 justify-content-end text-right" v-if="hasMultiple">
          <button class="addButton2" @click="copyReceiptValues(revConfirm.receiptDetail)">
            <span>필수 정보 일괄 입력</span>
          </button>
        </div>
      </div>
      <div class="row pt-3">
        <div class="col-12 headerTitle2">
          <span class="headerDetailText2">클릭 시 다른 일정에도 필수 정보가 반영됩니다. </span>
        </div>
      </div>
      <div class="row pt-3 pl-0 pr-0">
        <div class="col">
          <b-form-radio-group
            size="sm"
            class="d-flex flex-column"
            v-model="revConfirm.receiptDetail._bookedBy"
            @change="bookedByChanged($event, revConfirm.receiptDetail)"
          >
            <b-form-radio class="pt-1" v-if="isCompany" value="SelfBook">
              <div class="d-flex">
                <div class="">본인/배우자{{ reservTextJubsuYeyak }}</div>
                <div class="pl-2" style="margin-top: -0.5rem; padding-left: 0.5rem">
                  <b-form-select
                    class="rounded-0 icon-chevron-down"
                    :disabled="revConfirm.receiptDetail._bookedBy !== 'SelfBook'"
                    v-model="revConfirm.receiptDetail._selected_RealUserSelfOrFamily"
                    :options="options_RealUserSelfOrFamily"
                    @change="selected_RealUserSelfOrFamily_Changed($event, revConfirm.receiptDetail)"
                  ></b-form-select>
                </div>
              </div>
            </b-form-radio>
            <b-form-radio class="pt-1" v-if="isCompany" value="Recommender" :disabled="isNotRecomValid"
              >추천인{{ reservTextJubsuYeyak }}</b-form-radio
            >
          </b-form-radio-group>
        </div>
      </div>
      <hr />
    </div>

    <div class="detailInput">
      <!-- 이용자정보 web -->
      <div class="web" v-if="isCompany">
        <div class="header2">
          <div class="headerTitle">
            <span class="headerText">이용자</span>
            <span class="headerDetailText">실제 이용하시는 고객의 정보입니다. </span>
          </div>
          <div class="headerOption2">
            <div class="" v-if="revConfirm.receiptDetail._bookedBy === 'SelfBook' && isCompany">
              <!--              <b-form-select-->
              <!--                v-model="revConfirm.receiptDetail._selected_RealUserSelfOrFamily"-->
              <!--                :options="options_RealUserSelfOrFamily"-->
              <!--                @change="selected_RealUserSelfOrFamily_Changed($event, revConfirm.receiptDetail)"-->
              <!--              ></b-form-select>-->
            </div>
          </div>
        </div>
        <div class="detailInputRow" v-if="isCompany">
          <div class="detailInputRowLeft d-flex justify-content-center">
            <span>성명</span><span class="red">*</span>
          </div>
          <div class="detailInputRowCenter">
            <FormRequiredInput
              :readonly="revConfirm.receiptDetail._bookedBy === 'SelfBook' && isCompany"
              v-model="revConfirm.receiptDetail.gscName"
              placeholder="이름을 입력하세요."
            ></FormRequiredInput>
          </div>
          <div class="detailInputRowLeft d-flex justify-content-center align-items-center">
            <span>연락처</span><span class="red">*</span>
          </div>
          <div class="detailInputRowCenter">
            <FormTel
              :readonly="
                revConfirm.receiptDetail._bookedBy === 'SelfBook' &&
                isCompany &&
                !revConfirm.receiptDetail._gscHpNoBlank
              "
              v-model="revConfirm.receiptDetail.gscHpNo"
              placeholder="연락처를 입력하세요."
            ></FormTel>
          </div>
          <div
            class="detailInputRowCenter d-flex justify-content-end align-items-center align-items-center sms-checkbox"
          >
            <b-form-checkbox
              v-model="revConfirm.receiptDetail.gscSmsSendYn"
              name="check-button"
              value="Y"
              unchecked-value="N"
              button-variant="secondary"
              @change="changeGscSmsSendYn"
            >
              <b> SMS 수신 </b>
              <!--              <b v-if="revConfirm.receiptDetail.gscSmsSendYn == 'Y'">SMS 수신</b>-->
              <!--              <b v-else>SMS 미수신</b>-->
            </b-form-checkbox>
          </div>
        </div>
        <hr />
      </div>

      <!-- 이용자정보 모바일 -->
      <div class="mobile" v-if="isCompany">
        <div class="row">
          <div class="headerTitle col-5">
            <span class="headerText">이용자</span>
          </div>
          <div class="headerOption2 col-7 justify-content-end">
            <div class="" v-if="revConfirm.receiptDetail._bookedBy === 'SelfBook' && isCompany">
              <!--              <b-form-select-->
              <!--                v-model="revConfirm.receiptDetail._selected_RealUserSelfOrFamily"-->
              <!--                :options="options_RealUserSelfOrFamily"-->
              <!--                @change="selected_RealUserSelfOrFamily_Changed($event, revConfirm.receiptDetail)"-->
              <!--              ></b-form-select>-->
            </div>
          </div>
        </div>
        <div class="row py-2">
          <div class="col-12">
            <span class="headerDetailText">실제 이용하시는 고객의 정보입니다. </span>
          </div>
        </div>

        <div class="detailInputRow row" v-if="isCompany">
          <div class="detailInputRowLeft col-3"><span>성명</span><span class="red">*</span></div>
          <div class="detailInputRowCenter col-9">
            <FormRequiredInput
              :readonly="revConfirm.receiptDetail._bookedBy === 'SelfBook' && isCompany"
              v-model="revConfirm.receiptDetail.gscName"
              placeholder="이용자 이름을 입력하세요."
            ></FormRequiredInput>
          </div>
          <!--        <div class="detailInputRowRight" v-if="revConfirm.receiptDetail._bookedBy === 'SelfBook' && isCompany">-->
          <!--          <b-form-select-->
          <!--            v-model="revConfirm.receiptDetail._selected_RealUserSelfOrFamily"-->
          <!--            :options="options_RealUserSelfOrFamily"-->
          <!--            @change="selected_RealUserSelfOrFamily_Changed($event, revConfirm.receiptDetail)"-->
          <!--          ></b-form-select>-->
          <!--        </div>-->
        </div>
        <div class="detailInputRow row" v-if="isCompany">
          <div class="detailInputRowLeft col-3"><span>연락처</span><span class="red">*</span></div>
          <div class="detailInputRowCenter col-9">
            <FormTel
              :readonly="
                revConfirm.receiptDetail._bookedBy === 'SelfBook' &&
                isCompany &&
                !revConfirm.receiptDetail._gscHpNoBlank
              "
              v-model="revConfirm.receiptDetail.gscHpNo"
              placeholder="연락처를 입력하세요."
            ></FormTel>
          </div>
        </div>
        <div class="detailInputRow row">
          <div class="detailInputRowLeft col-3">
            <span></span>
          </div>
          <div class="detailInputRowCenter col-9">
            <b-form-checkbox
              v-model="revConfirm.receiptDetail.gscSmsSendYn"
              name="check-button"
              value="Y"
              unchecked-value="N"
              @change="changeGscSmsSendYn"
            >
              <b> SMS 수신 </b>
              <!--              <b v-if="revConfirm.receiptDetail.gscSmsSendYn == 'Y'">SMS 수신</b>-->
              <!--              <b v-else>SMS 미수신</b>-->
            </b-form-checkbox>
          </div>
        </div>
        <hr />
      </div>

      <!-- 예약자정보 web -->
      <div class="web">
        <div class="header2">
          <div class="headerTitle">
            <span class="headerText">예약자</span>
            <span class="headerDetailText">예약하시는 분의 정보입니다. </span>
          </div>
        </div>
        <div class="detailInputRow">
          <div class="detailInputRowLeft d-flex justify-content-center align-items-center">
            <span>성명</span>
          </div>
          <div class="detailInputRowCenter">
            <FormRequiredInput readonly v-model="revConfirm.receiptDetail.bookName" class="mr-2"></FormRequiredInput>
          </div>
          <div class="detailInputRowLeft d-flex justify-content-center align-items-center">
            <span>연락처</span>
          </div>
          <div class="detailInputRowCenter">
            <FormTel readonly v-model="revConfirm.receiptDetail.hpNo"></FormTel>
          </div>
          <div class="detailInputRowCenter d-flex justify-content-end align-items-center sms-checkbox">
            <b-form-checkbox
              v-model="revConfirm.receiptDetail.smsSendYn"
              name="check-button"
              value="Y"
              unchecked-value="N"
            >
              <b> SMS 수신 </b>
              <!--              <b v-if="revConfirm.receiptDetail.smsSendYn == 'Y'">SMS 수신</b>-->
              <!--              <b v-else>SMS 미수신</b>-->
            </b-form-checkbox>
          </div>
        </div>
      </div>

      <!-- 예약자정보 mobile -->
      <div class="mobile">
        <div class="row">
          <div class="headerTitle col-5">
            <span class="headerText">예약자</span>
          </div>
        </div>
        <div class="row py-2">
          <span class="headerDetailText col-12">예약하시는 분의 정보입니다. </span>
        </div>
        <div class="detailInputRow row">
          <div class="detailInputRowLeft col-3">
            <span>성명</span>
            <span class="red">*</span>
          </div>
          <div class="detailInputRowCenter col-9">
            <FormRequiredInput readonly v-model="revConfirm.receiptDetail.bookName" class="mr-2"></FormRequiredInput>
          </div>
        </div>
        <div class="detailInputRow row">
          <div class="detailInputRowLeft col-3"><span>연락처</span><span class="red">*</span></div>
          <div class="detailInputRowCenter col-9">
            <FormTel readonly v-model="revConfirm.receiptDetail.hpNo"></FormTel>
          </div>
        </div>
        <div class="detailInputRow row">
          <div class="detailInputRowLeft col-3">
            <span></span>
          </div>
          <div class="detailInputRowCenter col-9 sms-checkbox">
            <b-form-checkbox
              v-model="revConfirm.receiptDetail.smsSendYn"
              name="check-button"
              value="Y"
              unchecked-value="N"
            >
              <b> SMS 수신 </b>
              <!--              <b v-if="revConfirm.receiptDetail.smsSendYn == 'Y'">SMS 수신</b>-->
              <!--              <b v-else>SMS 미수신</b>-->
            </b-form-checkbox>
          </div>
        </div>
      </div>

      <hr />

      <!-- 신청자정보  web -->
      <div class="web">
        <div class="header2">
          <div class="headerTitle">
            <span class="headerText">신청자</span>
            <span class="headerDetailText">신청하시는 분의 정보입니다. </span>
          </div>
          <div class="headerOption3">
            <b-form-checkbox
              v-model="revConfirm.receiptDetail._receiptDetail_RealUserSame"
              class="ml-auto text-nowrap d-flex align-items-center"
              @change="receiptDetail_RealUserSameChanged($event, revConfirm.receiptDetail)"
            >
              예약자와 동일
            </b-form-checkbox>
          </div>
        </div>
        <div class="detailInputRow">
          <div class="detailInputRowLeft d-flex justify-content-center align-items-center">
            <span>성명<span class="red">*</span></span>
          </div>
          <div class="detailInputRowCenter">
            <FormRequiredInput
              :readonly="revConfirm.receiptDetail._receiptDetail_RealUserSame"
              v-model="revConfirm.receiptDetail.regName"
              placeholder="신청 담당자명을 입력 하세요."
              class="mr-2"
            ></FormRequiredInput>
          </div>

          <div class="detailInputRowLeft d-flex justify-content-center align-items-center">
            <span>연락처<span class="red">*</span></span>
          </div>

          <div class="detailInputRowCenter">
            <FormTel
              :readonly="revConfirm.receiptDetail._receiptDetail_RealUserSame"
              v-model="revConfirm.receiptDetail.regHpNo"
              placeholder="연락처를 입력하세요."
            ></FormTel>
          </div>
          <div class="detailInputRowCenter d-flex justify-content-end align-items-center sms-checkbox">
            <b-form-checkbox
              v-model="revConfirm.receiptDetail.regSmsSendYn"
              name="check-button"
              value="Y"
              unchecked-value="N"
              @change="changeRegSmsSendYn"
            >
              <b> SMS 수신 </b>
              <!--              <b v-if="revConfirm.receiptDetail.regSmsSendYn == 'Y'">SMS 수신</b>-->
              <!--              <b v-else>SMS 미수신</b>-->
            </b-form-checkbox>
          </div>
        </div>
      </div>

      <!-- 신청자정보 mobile -->
      <div class="mobile">
        <div class="row">
          <div class="headerTitle col-5">
            <span class="headerText">신청자</span>
          </div>
          <div class="col-7 justify-content-end text-right align-self-center">
            <b-form-checkbox
              v-model="revConfirm.receiptDetail._receiptDetail_RealUserSame"
              class="ml-auto text-nowrap d-flex justify-content-end"
              @change="receiptDetail_RealUserSameChanged($event, revConfirm.receiptDetail)"
            >
              예약자와 동일
            </b-form-checkbox>
          </div>
        </div>
        <div class="row">
          <span class="col-12 py-2">신청하시는 분의 정보입니다. </span>
        </div>
        <div class="detailInputRow row">
          <div class="detailInputRowLeft col-3">
            <span>성명<span class="red">*</span></span>
          </div>
          <div class="detailInputRowCenter col-9">
            <FormRequiredInput
              :readonly="revConfirm.receiptDetail._receiptDetail_RealUserSame"
              v-model="revConfirm.receiptDetail.regName"
              placeholder="신청 담당자명을 입력 하세요."
              class="mr-2"
            ></FormRequiredInput>
          </div>
        </div>
        <div class="detailInputRow row">
          <div class="detailInputRowLeft col-3">
            <span>연락처<span class="red">*</span></span>
          </div>

          <div class="detailInputRowCenter col-9">
            <FormTel
              :readonly="revConfirm.receiptDetail._receiptDetail_RealUserSame"
              v-model="revConfirm.receiptDetail.regHpNo"
              :required="false"
              placeholder="연락처를 입력하세요."
            ></FormTel>
          </div>
        </div>
        <div class="detailInputRow row">
          <div class="detailInputRowLeft col-3">
            <span></span>
          </div>
          <div class="detailInputRowCenter col-9 sms-checkbox">
            <b-form-checkbox
              v-model="revConfirm.receiptDetail.regSmsSendYn"
              name="check-button"
              value="Y"
              unchecked-value="N"
              @change="changeRegSmsSendYn"
            >
              <b> SMS 수신 </b>
              <!--              <b v-if="revConfirm.receiptDetail.regSmsSendYn == 'Y'">SMS 수신</b>-->
              <!--              <b v-else>SMS 미수신</b>-->
            </b-form-checkbox>
          </div>
        </div>
      </div>

      <hr />

      <!-- 인원수 정보  web -->
      <div class="web">
        <div class="header2">
          <div class="headerTitle">
            <div></div>
            <span class="headerText">인원수</span>
            <span class="headerDetailText">사용가능한 최대 인원은 {{ MAN_WOMAN_TOTAL_COUNT }}명입니다. </span>
          </div>
        </div>
        <div class="detailInputRow">
          <div class="detailInputRowLeft d-flex justify-content-center align-items-center">
            <span>인원 수</span><span class="red">*</span>
          </div>
          <div class="detailInputRowCenter2">
            <div>
              <div class="detailInputRowCenter2Item1 mr-3">남자</div>
              <div class="detailInputRowCenter2Item2">
                <b-form-spinbutton
                  v-model="revConfirm.receiptDetail.teamManCnt"
                  :min="0"
                  :max="getMaxManCount(revConfirm.receiptDetail)"
                  @change="refreshManCount"
                ></b-form-spinbutton>
              </div>

              <!--            <b-form-select-->
              <!--              v-model="revConfirm.receiptDetail.teamManCnt"-->
              <!--              :options="options_TeamCount(revConfirm.receiptDetail.teamWomanCnt)"-->
              <!--            ></b-form-select>-->
            </div>

            <div class="detailInputRowCenter2Item1"></div>
            <div>
              <div class="detailInputRowCenter2Item1 mr-3">여자</div>
              <div class="detailInputRowCenter2Item2">
                <b-form-spinbutton
                  v-model="revConfirm.receiptDetail.teamWomanCnt"
                  :min="0"
                  :max="getMaxWomanCount(revConfirm.receiptDetail)"
                  @change="refreshWomanCount"
                ></b-form-spinbutton>
                <!--            <b-form-select-->
                <!--              v-model="revConfirm.receiptDetail.teamWomanCnt"-->
                <!--              :options="options_TeamCount(revConfirm.receiptDetail.teamManCnt)"-->
                <!--            ></b-form-select>-->
              </div>
            </div>
            <div class="detailInputRowCenter2ItemTerm"></div>
          </div>
        </div>
      </div>

      <!-- 인원수 정보  mobile -->
      <div class="mobile">
        <div class="row">
          <div class="headerTitle col-5"><span class="headerText">인원수</span><span class="red">*</span></div>
        </div>
        <div class="row py-2">
          <span class="headerDetailText col-12">사용가능한 최대 인원은 {{ MAN_WOMAN_TOTAL_COUNT }}명입니다. </span>
        </div>

        <div class="row pt-2">
          <div class="detailInputRowLeft col-3">
            <span>남자</span>
          </div>
          <div class="detailInputRowCenter2Item2 col-9">
            <b-form-spinbutton
              v-model="revConfirm.receiptDetail.teamManCnt"
              :min="0"
              :max="getMaxManCount(revConfirm.receiptDetail)"
              @change="refreshManCount"
            ></b-form-spinbutton>
          </div>
        </div>

        <div class="row pt-2">
          <div class="detailInputRowLeft col-3">
            <span>여자</span>
          </div>
          <div class="detailInputRowCenter2Item2 col-9">
            <b-form-spinbutton
              v-model="revConfirm.receiptDetail.teamWomanCnt"
              :min="0"
              :max="getMaxWomanCount(revConfirm.receiptDetail)"
              @change="refreshWomanCount"
            ></b-form-spinbutton>
          </div>
        </div>
      </div>

      <hr />
      <!-- 카트 정보  web -->
      <div class="web">
        <div class="header2">
          <div class="headerTitle">
            <div>
              <span class="headerText">리무진 카트</span>
              <span class="headerDetailText">프리미엄 리무진 카트는 팀당 1대만 추가 가능합니다. (카트비 22만원)</span>
            </div>
          </div>

          <div class="headerOption">
            <div class="optionBtnGroup">
              <button
                class="addButton"
                variant="outline-primary"
                @click="addRentItem('ETC', revConfirm.receiptDetail._rentListCarts, revConfirm.receiptDetail)"
              >
                <span>+ 리무진 카트 추가</span>
              </button>
            </div>
          </div>
        </div>
        <div class="detailInputRow2">
          <div class="detailInputRowLeft d-flex justify-content-center align-items-center">
            <!--            <span>대여채</span>-->
          </div>

          <div class="detailInputRowCenter">
            <div class="detailInputRowCenter3" v-for="(r, i) in revConfirm.receiptDetail._rentListCarts" :key="i">
              <div class="detailInputRowCenter2Item1">
                <span>종류</span>
              </div>
              <div class="item-box">
                {{ rentListOptions('ETC', r)[0].text }}
                <!--                  <b-form-select-->
                <!--                    class="rounded-0 icon-chevron-down"-->
                <!--                    v-model="r._idx"-->
                <!--                    :options="rentListOptions('ETC', r)"-->
                <!--                    @change="rentChanged(r)"-->
                <!--                  ></b-form-select>-->
              </div>
              <div class="detailInputRowCenter2ItemTerm"></div>
              <div class="detailInputRowCenter2Item1">
                <span>수량</span>
              </div>
              <div class="item-box">
                <!--                  <b-form-spinbutton v-model="r.saleQty" min="1" max="1"></b-form-spinbutton>-->
                {{ r.saleQty }}
              </div>
              <div class="detailInputRowCenter2ItemTerm"></div>
              <div class="detailInputRowCenter2Item1">
                <button class="deleteButton" @click="removeRentItemClub(revConfirm.receiptDetail._rentListCarts, i)">
                  <span>삭제</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 카트 정보  mobile -->
      <div class="mobile">
        <div class="row">
          <div class="headerTitle col-7">
            <div>
              <span class="headerText">리무진 카트</span>
            </div>
          </div>
          <div class="optionBtnGroup col-5">
            <button
              class="addButton"
              variant="outline-primary"
              @click="addRentItem('ETC', revConfirm.receiptDetail._rentListCarts, revConfirm.receiptDetail)"
            >
              <span>+ 리무진 카트 추가</span>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="mobileMargin col-12 pt-2">
            <span class="headerDetailText">프리미엄 리무진 카트는 팀당 1대만 추가 가능합니다. (카트비 22만원)</span>
          </div>
        </div>
        <div class="row mt-2 p-1" v-for="(r, i) in revConfirm.receiptDetail._rentListCarts" :key="i">
          <div class="col-12">
            <div class="row">
              <div class="detailInputRowLeft col-3">
                <span>종류</span>
              </div>
              <div class="col-9">
                <div class="item-box">
                  {{ rentListOptions('ETC', r)[0].text }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="detailInputRowLeft col-3">
                <span>수량</span>
              </div>
              <div class="col-9">
                <div class="item-box">
                  {{ r.saleQty }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-9" />
              <div class="col-3">
                <button class="deleteButton" @click="removeRentItemClub(revConfirm.receiptDetail._rentListCarts, i)">
                  <span>삭제</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <!-- 대여채 정보  web -->
      <div class="web">
        <div class="header2">
          <div class="headerTitle">
            <div>
              <span class="headerText">대여채</span>
              <span class="headerDetailText">대여채는 최대 인원수만큼 추가 가능합니다.</span>
            </div>
          </div>

          <div class="headerOption">
            <div class="optionBtnGroup">
              <button
                class="addButton"
                variant="outline-primary"
                @click="addRentItem('CLUB', revConfirm.receiptDetail._rentListClub, revConfirm.receiptDetail)"
              >
                <span>+ 대여채 추가</span>
              </button>
            </div>
          </div>
        </div>
        <div class="detailInputRow2">
          <div class="detailInputRowLeft d-flex justify-content-center align-items-center">
            <!--            <span>대여채</span>-->
          </div>

          <div class="detailInputRowCenter">
            <div class="detailInputRowCenter3" v-for="(r, i) in revConfirm.receiptDetail._rentListClub" :key="i">
              <div class="detailInputRowCenter2Item1">
                <span>종류</span>
              </div>
              <div class="detailInputRowCenter2Item2">
                <b-form-select
                  class="rounded-0 icon-chevron-down"
                  v-model="r._idx"
                  :options="rentListOptions('CLUB', r)"
                  @change="rentChanged(r)"
                ></b-form-select>
              </div>
              <div class="detailInputRowCenter2ItemTerm"></div>
              <div class="detailInputRowCenter2Item1">
                <span>수량</span>
              </div>
              <div class="detailInputRowCenter2Item2">
                <b-form-spinbutton v-model="r.saleQty" min="1" :max="MAN_WOMAN_TOTAL_COUNT"></b-form-spinbutton>
              </div>
              <div class="detailInputRowCenter2ItemTerm"></div>
              <div class="detailInputRowCenter2Item1">
                <button class="deleteButton" @click="removeRentItemClub(revConfirm.receiptDetail._rentListClub, i)">
                  <span>삭제</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 대여채 정보  mobile -->
      <div class="mobile">
        <div class="row">
          <div class="headerTitle col-7">
            <div>
              <span class="headerText">대여채</span>
            </div>
          </div>
          <div class="optionBtnGroup col-5">
            <button
              class="addButton"
              variant="outline-primary"
              @click="addRentItem('CLUB', revConfirm.receiptDetail._rentListClub, revConfirm.receiptDetail)"
            >
              <span>+ 대여채 추가</span>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="mobileMargin col-12 pt-2">
            <span class="headerDetailText">대여채는 최대 인원수만큼 추가 가능합니다.</span>
          </div>
        </div>
        <div class="row mt-2 p-1" v-for="(r, i) in revConfirm.receiptDetail._rentListClub" :key="i">
          <div class="col-12">
            <div class="row">
              <div class="detailInputRowLeft col-3">
                <span>종류</span>
              </div>
              <div class="col-9">
                <b-form-select
                  class="rounded-0 icon-chevron-down"
                  v-model="r._idx"
                  :options="rentListOptions('CLUB', r)"
                  @change="rentChanged(r)"
                ></b-form-select>
              </div>
            </div>
            <div class="row">
              <div class="detailInputRowLeft col-3">
                <span>수량</span>
              </div>
              <div class="col-9">
                <b-form-spinbutton v-model="r.saleQty" min="1" :max="MAN_WOMAN_TOTAL_COUNT"></b-form-spinbutton>
              </div>
            </div>
            <div class="row">
              <div class="col-9" />
              <div class="col-3">
                <button class="deleteButton" @click="removeRentItemClub(revConfirm.receiptDetail._rentListClub, i)">
                  <span>삭제</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />

      <!-- 대여화 정보  web -->
      <div class="web">
        <div class="header2">
          <div class="headerTitle">
            <div>
              <span class="headerText">대여화</span>
              <span class="headerDetailText">대여화는 최대 인원수만큼 추가 가능합니다.</span>
            </div>
          </div>

          <div class="headerOption">
            <div class="optionBtnGroup">
              <button
                class="addButton"
                variant="outline-primary"
                @click="addRentItem('SHOES', revConfirm.receiptDetail._rentListShoes, revConfirm.receiptDetail)"
              >
                <span>+ 대여화 추가</span>
              </button>
            </div>
          </div>
        </div>
        <div class="detailInputRow2">
          <div class="detailInputRowLeft d-flex justify-content-center align-items-center">
            <!--            <span>대여화</span>-->
          </div>

          <div class="detailInputRowCenter">
            <div class="detailInputRowCenter3" v-for="(r, i) in revConfirm.receiptDetail._rentListShoes" :key="i">
              <div class="detailInputRowCenter2Item1">
                <span>종류</span>
              </div>
              <div class="detailInputRowCenter2Item2">
                <b-form-select
                  class="rounded-0 icon-chevron-down"
                  v-model="r._idx"
                  :options="rentListOptions('SHOES', r)"
                  @change="rentChanged"
                ></b-form-select>
              </div>
              <div class="detailInputRowCenter2ItemTerm"></div>
              <div class="detailInputRowCenter2Item1">
                <span>수량</span>
              </div>
              <div class="detailInputRowCenter2Item2">
                <b-form-spinbutton v-model="r.saleQty" min="1" :max="MAN_WOMAN_TOTAL_COUNT"></b-form-spinbutton>
              </div>
              <div class="detailInputRowCenter2ItemTerm"></div>
              <div class="detailInputRowCenter2Item1">
                <button class="deleteButton" @click="removeRentItemClub(revConfirm.receiptDetail._rentListShoes, i)">
                  <span>삭제</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 대여화 정보  mobile -->
      <div class="mobile">
        <div class="row">
          <div class="headerTitle col-7">
            <div>
              <span class="headerText">대여화</span>
            </div>
          </div>
          <div class="optionBtnGroup col-5">
            <button
              class="addButton"
              variant="outline-primary"
              @click="addRentItem('SHOES', revConfirm.receiptDetail._rentListShoes, revConfirm.receiptDetail)"
            >
              <span>+ 대여화 추가</span>
            </button>
          </div>
        </div>
        <div class="row pt-2">
          <div class="mobileMargin col-12">
            <span class="headerDetailText">대여화는 최대 인원수만큼 추가 가능합니다. </span>
          </div>
        </div>

        <div class="row mt-2 p-1" v-for="(r, i) in revConfirm.receiptDetail._rentListShoes" :key="i">
          <div class="col-12">
            <div class="row">
              <div class="detailInputRowCenter2Item1 col-3">
                <span>종류</span>
              </div>
              <div class="detailInputRowCenter2Item2 col-9">
                <b-form-select
                  class="rounded-0 icon-chevron-down"
                  v-model="r._idx"
                  :options="rentListOptions('SHOES', r)"
                  @change="rentChanged"
                ></b-form-select>
              </div>
            </div>
            <div class="row">
              <div class="detailInputRowCenter2Item1 col-3">
                <span>수량</span>
              </div>
              <div class="detailInputRowCenter2Item2 col-9">
                <b-form-spinbutton v-model="r.saleQty" min="1" :max="getMaxCountOfRentItem(r)"></b-form-spinbutton>
              </div>
            </div>
            <div class="row">
              <div class="col-9"></div>
              <div class="detailInputRowCenter2Item1 col-3">
                <button class="deleteButton" @click="removeRentItemClub(revConfirm.receiptDetail._rentListShoes, i)">
                  <span>삭제</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 대여채/대여화 안내 문구 web -->
      <div class="web">
        <div class="rentNotice">
          <p class="font-weight-bold text-blue">
            ※ 클럽 및 골프화 대여는 본인/배우자 우선 배정으로 잔여 수량 부족 시 대여가 제한될 수 있습니다.<br />
            대여 확정 여부는 배정 완료 후 마이페이지에서 확인해 주시기 바랍니다.
          </p>
        </div>
      </div>

      <!-- 대여채/대여화 안내 문구 mobile -->
      <div class="mobile">
        <div class="row pt-2">
          <div class="mobileMargin col-12 rentNotice">
            <p class="font-weight-bold text-blue">
              ※ 클럽 및 골프화 대여는 본인/배우자 우선 배정으로 잔여 수량 부족 시 대여가 제한될 수 있습니다.<br />대여
              확정 여부는 배정 완료 후 마이페이지에서 확인해 주시기 바랍니다.
            </p>
          </div>
        </div>
      </div>

      <hr />

      <div class="header2">
        <div class="headerTitle">
          <span class="headerText">추가요청사항(기타)</span>
        </div>
      </div>
      <div class="detailInputRow3">
        <div>
          <b-form-textarea
            v-model="revConfirm.receiptDetail.remarks"
            placeholder="ex) 전시간대 무관합니다."
            rows="3"
            max-rows="3"
          ></b-form-textarea>
        </div>
      </div>
    </div>
  </div>
</template>

<!--export type BookByType = 'SelfBook' | 'Recommender';-->
<script>
import {PMSReqGolfReceiptNewDetail, PMSReqGolfReceiptNewRent, ReserveNameHp} from '@/models-golf';
import {BV_OptionItemGeneral, BV_OptionItemNumber} from '@/models';
import reserveService from '@/services/rev.service';

import FormRequiredInput from '@/components/forms/FormRequiredInput';
import FormTel from '@/components/forms/FormTel';
import GeneralUtil, {phoneFomatter} from '@/util/GeneralUtil';

const MAN_WOMAN_TOTAL_COUNT = 4;

export default {
  name: 'ReceiptInputForm',
  mixins: [GeneralUtil],
  components: {FormTel, FormRequiredInput},
  props: {
    listType: String,
    revConfirm: Object,
    hasMultiple: Boolean,
  },
  data() {
    return {
      receiptDateCheck: {reservCount: 0, limitCount: 1, recomValidYn: 'N'},
      clubOptions: [],
      shoesOptions: [],
      MAN_WOMAN_TOTAL_COUNT: MAN_WOMAN_TOTAL_COUNT,
    };
  },
  async created() {
    console.log('@@@@', this.revConfirm);
    const reqResult = await reserveService.getRevCountCheck(
      this.listType,
      this.revConfirm.selectedDate,
      this.selectedMember.memNo,
    );

    this.receiptDateCheck = reqResult.obj;
    this.revConfirm.receiptDetail._recomValidYn = this.receiptDateCheck.recomValidYn;

    const reqResult2 = await reserveService.getRentList(this.revConfirm.selectedDate);
    this.revConfirm.receiptDetail.rentList = reqResult2.items;
    console.log('this.rentList', this.rentList);

    this.receiptDetail_RealUserSameChanged(
      this.revConfirm.receiptDetail._receiptDetail_RealUserSame,
      this.revConfirm.receiptDetail,
    );

    this.clubOptions = this.rentListOptions('CLUB');
    this.shoesOptions = this.rentListOptions('SHOES');

    // 법인Pkg가 아닐경우 이용자 정보 설정이 안되므로 이곳에서 강제 설정
    if (!this.isCompany) {
      this.revConfirm.receiptDetail.gscName = this.loginUser.guestName;
      this.revConfirm.receiptDetail.gscHpNo = this.loginUser.hpNo;
      this.revConfirm.receiptDetail.gscGuestNo = this.loginUser.guestNo;
    }

    //예약자 정보는 현재 로그인한 사람
    this.revConfirm.receiptDetail.bookName = this.loginUser.guestName;
    this.revConfirm.receiptDetail.hpNo = this.loginUser.hpNo;
  },
  computed: {
    loginUser() {
      return this.$store.getters['Auth/loginUser'];
    },

    selectedMember() {
      return this.$store.getters['Auth/selectedMember'];
    },

    isCompany() {
      let user = this.$store.getters['Auth/selectedMember'];
      // 법인회원 코드 : 006
      return user.memType === '006';
    },
    isNotRecomValid() {
      return this.receiptDateCheck.recomValidYn === 'N';
    },
    reservTextJubsuYeyak() {
      switch (this.listType) {
        case 'RECEIPT':
          return '접수';
        case 'WAIT':
          return '접수';
        case 'REAL':
          return '예약';
        default:
          return '';
      }
    },

    reservTextNaejangYeyak() {
      switch (this.listType) {
        case 'RECEIPT':
          return '내장';
        case 'WAIT':
          return '내장';
        case 'REAL':
          return '예약';
        default:
          return '';
      }
    },

    options_RealUserSelfOrFamily() {
      // [
      //   { value: 'Y', text: '본인 내장' },
      //   { value: 'N', text: '배우자 내장' },
      // ];
      // TODO : 회원권 여러개 있는 회원일 경우(극소수) memInfoArr[0] 이외의 다른 값 선택 필요함
      const memberSelected = this.selectedMember;

      // 본인
      let res = [
        {
          value: {
            gscName: '',
            gscHpNo: '',
          },
          text: '이용자 선택',
        },
        {
          value: {
            gscName: this.loginUser.guestName,
            gscHpNo: this.loginUser.hpNo,
            gscGuestNo: this.loginUser.guestNo,
          },
          text: `${memberSelected.guestTypeName} ${this.reservTextNaejangYeyak}`,
        },
      ];

      // 가족 리스트
      if (memberSelected.familyInfoArr && memberSelected.familyInfoArr.length > 0) {
        this.selectedMember.familyInfoArr.forEach(x => {
          res.push({
            value: {
              gscName: x.guestName,
              gscHpNo: x.hpNo,
              gscGuestNo: x.guestNo,
            },
            text: `${x?.relationName} 내장`,
          });
        });
      }

      return res;
    },
  },
  methods: {
    phoneFomatter: phoneFomatter,
    async changeGscSmsSendYn(checked) {
      console.log('checked', checked, this.revConfirm.receiptDetail.gscHpNo);
      if (checked === 'Y' && this.revConfirm.receiptDetail.gscHpNo === '') {
        await this.showMsgBoxOkPmsErr('이용자 연락처를 입력해주세요.');
        this.revConfirm.receiptDetail.gscSmsSendYn = 'N';
      }
    },
    async changeRegSmsSendYn(checked) {
      console.log('checked', checked, this.revConfirm.receiptDetail.regHpNo);
      if (checked === 'Y' && this.revConfirm.receiptDetail.regHpNo === '') {
        await this.showMsgBoxOkPmsErr('신청자 연락처를 입력해주세요.');
        this.revConfirm.receiptDetail.regSmsSendYn = 'N';
      }
    },
    getMaxCountOfRentItem(rentItem) {
      const sexIdOfRItem = this.revConfirm.receiptDetail.rentList[rentItem._idx].sexId;
      if (sexIdOfRItem === 'M') return this.revConfirm.receiptDetail.teamManCnt;
      else if (sexIdOfRItem === 'F') return this.revConfirm.receiptDetail.teamWomanCnt;
      else return 0;
    },
    limitRentArray(arr, maxValue, sexId) {
      let totalSaleQty = 0;
      let filteredArr = arr.filter(x => this.revConfirm.receiptDetail.rentList[x._idx].sexId === sexId);
      console.log(filteredArr);
      filteredArr.forEach(x => {
        totalSaleQty += x.saleQty;
      });
      if (totalSaleQty > maxValue) {
        let lastItem = filteredArr[filteredArr.length - 1];
        lastItem.saleQty--;
        if (lastItem.saleQty === 0) {
          arr.splice(
            arr.findIndex(x => x._idx === lastItem._idx),
            1,
          );
        }
      }
    },
    refreshManCount(newValue) {
      console.log(newValue);
      // 대여채 정보는 변화시키지 않는다.
      //this.limitRentArray(this.revConfirm.receiptDetail._rentListClub, this.revConfirm.receiptDetail.teamManCnt, 'M');
      this.limitRentArray(this.revConfirm.receiptDetail._rentListShoes, this.revConfirm.receiptDetail.teamManCnt, 'M');
    },
    refreshWomanCount() {
      console.log();
      // 대여채 정보는 변화시키지 않는다.
      //this.limitRentArray(this.revConfirm.receiptDetail._rentListClub, this.revConfirm.receiptDetail.teamWomanCnt, 'F');
      this.limitRentArray(
        this.revConfirm.receiptDetail._rentListShoes,
        this.revConfirm.receiptDetail.teamWomanCnt,
        'F',
      );
    },
    selected_RealUserSelfOrFamily_Changed(value, rd) {
      console.log('selected_RealUserSelfOrFamily_Changed', value, rd);
      rd.gscName = value.gscName;
      rd.gscHpNo = value.gscHpNo;
      rd.gscGuestNo = value.gscGuestNo;

      // 배우자의 이름은 있는데 연락처가 설정되지 않은경우 readonly = false;
      rd._gscHpNoBlank = value.gscName && !value.gscHpNo.trim() ? true : false;
    },

    receiptDetail_RealUserSameChanged(value, rd) {
      if (value) {
        rd.regName = this.loginUser.guestName;
        rd.regHpNo = this.loginUser.hpNo;
      } else {
        rd.regName = '';
        rd.regHpNo = '';
      }
    },

    bookedByChanged(value, rd) {
      //console.log(`bookedByChanged/${value}/${this.isMyMemTypeBubin}/`);
      if (value === 'SelfBook') {
        if (this.isMyMemTypeBubin) {
          this.selected_RealUserSelfOrFamily_Changed(rd._selected_RealUserSelfOrFamily, rd);
        } else {
          rd.gscName = this.loginUser.guestName;
          rd.gscHpNo = this.loginUser.hpNo;
          rd.gscGuestNo = this.loginUser.guestNo;
        }
      } else {
        rd.gscName = '';
        rd.gscHpNo = '';
        rd.gscGuestNo = '';
      }
    },

    copyReceiptValues: async function (rd) {
      // EVENT EMIT
      //이용자, 신청자 정보 입력확인
      if (rd.gscName === '') {
        await this.showMsgBoxOkPmsErr('이용자 이름을 입력해주세요.');
        return;
      }
      if (rd.gscHpNo === '') {
        await this.showMsgBoxOkPmsErr('이용자 연락처를 입력해주세요.');
        return;
      }
      if (rd.regName === '') {
        await this.showMsgBoxOkPmsErr('신청자 이름을 입력해주세요.');
        return;
      }
      if (rd.regHpNo === '') {
        await this.showMsgBoxOkPmsErr('신청자 연락처를 입력해주세요.');
        return;
      }

      let result = await this.$bvModal.msgBoxConfirm(
        this.htmlToVNode(
          `모든 접수에 동일한 정보를 적용하시겠습니까? <br /> <div style="font-size: 0.8rem; color: #555555; margin-top: 1rem"> ※ 내장자가 다른 건은 제외 후 별도 접수<br/>※ 대여채, 대여화 정보는 일자 별로 입력</div>`,
        ),

        {
          okTitle: '확인',
          cancelTitle: '취소',
          centered: true,
        },
      );

      if (result) {
        this.$EventBus.$emit('SetAllReceiptDetail', rd);
      }
    },

    addRentItem(t, list, rd) {
      //let maxCnt = rd.teamManCnt + rd.teamWomanCnt;
      let maxCnt = MAN_WOMAN_TOTAL_COUNT;

      if (t === 'CLUB') {
        let current = 0;
        rd._rentListClub.forEach(x => {
          current += x.saleQty;
        });
        // if (current >= maxCnt) return;
      } else if (t === 'SHOES') {
        let current = 0;
        rd._rentListShoes.forEach(x => {
          current += x.saleQty;
        });
        // if (current >= maxCnt) return;
      } else if (t === 'ETC') {
        let current = 0;
        rd._rentListCarts.forEach(x => {
          current += x.saleQty;
        });
        // if (current >= maxCnt) return;
      }

      // if (rd.teamManCnt + rd.teamWomanCnt <= list.push()) return;
      // 최대 4개까지 아이템 추가하도록 변경 이슈 73
      if (4 <= list.push()) return;

      let rentData = new PMSReqGolfReceiptNewRent();

      let availableIndex = [];

      let results = this.rentListOptions(t, rentData);
      availableIndex = results.map(x => {
        return x.value;
      });

      availableIndex = availableIndex.filter(r => {
        let existIndex = list.findIndex(_r => {
          return _r._idx === r;
        });
        return existIndex < 0;
      });

      if (availableIndex.length > 0) {
        console.log('===>', rentData._idx, availableIndex[0]);
        rentData._idx = availableIndex[0];
        list.push(rentData);
      } else {
        const typeLabel = {CLUB: '대여채', SHOES: '대여화', ETC: '리무진 카트'}[t] || '대여 품목';
        this.showMsgBoxOk(`추가 가능한 ${typeLabel} 정보가 없습니다.`, '안내');
      }
    },

    removeRentItemClub(list, i) {
      list.splice(i, 1);
    },

    rentChanged(target) {
      console.log('rentChanged', target, this.revConfirm.receiptDetail);
    },

    rentListOptions(classType, r) {
      let result = [];

      this.revConfirm.receiptDetail.rentList.forEach((x, idx) => {
        x.index = idx;
        if (x.itemSClassType === classType) {
          let sex = x.sexId === 'M' ? '남' : '여';
          if (classType === 'ETC') {
            //리무진 카트 menuCode만 입력되도록 수
            if (x.menuCode === '3999800025') {
              result.push({
                value: x.index,
                text: `${x.menuName} `,
              });
            }
          } else {
            result.push({
              value: x.index,
              text: `[${sex}] ${x.menuName} `,
            });
          }
        }
      });

      let availableIndex = [];
      if (classType === 'CLUB') {
        availableIndex = this.revConfirm.receiptDetail._rentListClub.map(x => {
          return x._idx;
        });
      } else if (classType === 'SHOES') {
        availableIndex = this.revConfirm.receiptDetail._rentListShoes.map(x => {
          return x._idx;
        });
      } else if (classType === 'ETC') {
        availableIndex = this.revConfirm.receiptDetail._rentListCarts.map(x => {
          return x._idx;
        });
      }

      result = result.filter(rr => {
        let existIndex = availableIndex.findIndex(a => {
          console.log(rr, a);
          return rr.value === a && rr.value !== r._idx;
        });
        return existIndex < 0;
      });

      console.log(result, availableIndex, r);
      // result.push(r);
      return result;
    },

    getMinManCount(rd) {
      let totalMin = 0;
      let current = rd.teamManCnt + rd.teamWomanCnt;

      let otherCount = 0;
      this.revConfirm.receiptDetail._rentListClub.forEach(x => {
        otherCount += x.saleQty;
      });

      this.revConfirm.receiptDetail._rentListShoes.forEach(x => {
        otherCount += x.saleQty;
      });

      if (current > otherCount) {
        return totalMin;
      } else {
        return rd.teamManCnt;
      }
    },
    getMinWomanCount(rd) {
      let totalMin = 0;
      let current = rd.teamManCnt + rd.teamWomanCnt;

      let otherCount = 0;
      this.revConfirm.receiptDetail._rentListClub.forEach(x => {
        otherCount += x.saleQty;
      });

      this.revConfirm.receiptDetail._rentListShoes.forEach(x => {
        otherCount += x.saleQty;
      });

      if (current > otherCount) {
        return totalMin;
      } else {
        return rd.teamWomanCnt;
      }
    },

    getMaxManCount(rd) {
      let current = rd.teamManCnt + rd.teamWomanCnt;
      console.log(MAN_WOMAN_TOTAL_COUNT, current);
      if (current < MAN_WOMAN_TOTAL_COUNT) {
        return MAN_WOMAN_TOTAL_COUNT - rd.teamWomanCnt;
      } else {
        return rd.teamManCnt;
      }
    },
    getMaxWomanCount(rd) {
      let current = rd.teamManCnt + rd.teamWomanCnt;
      console.log(MAN_WOMAN_TOTAL_COUNT, current);
      if (current < MAN_WOMAN_TOTAL_COUNT) {
        return MAN_WOMAN_TOTAL_COUNT - rd.teamManCnt;
      } else {
        return rd.teamWomanCnt;
      }
    },

    getClubRentItemMax(r) {
      let totalMax = this.revConfirm.receiptDetail.teamManCnt + this.revConfirm.receiptDetail.teamWomanCnt;
      let current = r.saleQty;

      if (current < totalMax) {
        let otherCount = 0;
        this.revConfirm.receiptDetail._rentListClub.forEach(x => {
          if (x._idx !== r._idx) {
            otherCount += x.saleQty;
          }
        });

        return totalMax - otherCount;
      } else {
        return r.saleQty;
      }
    },
    removeEventSpaces(e) {
      e.preventDefault();
      const left = e.target.value.substring(0, e.target.selectionStart);
      const right = e.target.value.substring(e.target.selectionEnd, e.target.value.length);
      const pasted = (e.dataTransfer || e.clipboardData).getData('text').replace(/ /g, '');
      e.target.value = left + pasted + right;
    },
  },
};
</script>

<style scoped lang="scss">
textarea::placeholder {
  color: #bfc3cb;
}

.outterBox {
  //  border-top: 1px solid #6e6e6e;
  background-color: #fafafa;
  padding: 1.5rem;
}

.header {
  //border: 1px solid #6e6e6e;
  //background-color: red;
  display: flex;
  height: 3rem;
  //border-bottom: 1px solid #eeeeee;
}

.header2 {
  //border: 1px solid #6e6e6e;
  //background-color: #eeeeee;
  display: flex;
  height: 3rem;
}

.headerTitle {
  vertical-align: middle;
  line-height: 3rem;
  width: 100%;
  .headerText {
    font-size: 1rem;
    font-weight: bold;
  }
  .headerDetailText {
    font-size: 0.8rem;
    color: #999999;
    margin-left: 2rem;
    width: 100%;
  }
}
.headerOption {
  display: inline-block;
  vertical-align: middle;
  line-height: 3rem;
  width: 20%;

  .optionBtnGroup {
    min-width: 8rem;
    display: block;
    float: right;
    //width: 20%;
  }
}

.headerOption2 {
  display: flex;
  vertical-align: middle;
  line-height: 3rem;
  text-align: right;
}
.headerOption3 {
  display: flex;
  width: 70%;
  vertical-align: middle;
}

.detailInput {
  .detailInputRow {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;

    display: flex;
    height: 2rem;
    .detailInputRowLeft {
      display: inline-block;
      width: 6rem;
      line-height: 2rem;
      text-align: left;
    }
    .detailInputRowCenter {
      display: inline-block;
      flex: 1;
    }

    .detailInputRowCenter2 {
      display: flex;
      flex: 1;
      .detailInputRowCenter2Item1 {
        display: inline-block;
        text-align: left;
        line-height: 2rem;
        flex: 1;
      }
      .detailInputRowCenter2Item2 {
        display: inline-block;
        flex: 5;
      }
      .detailInputRowCenter2ItemTerm {
        display: inline-block;
        flex: 2;
      }
    }

    .detailInputRowRight {
      display: inline-block;
      width: 12rem;
    }
  }

  .detailInputRow2 {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;

    display: flex;
    min-height: 2rem;
    .detailInputRowLeft {
      display: inline-block;
      width: 6rem;
      line-height: 2rem;
      text-align: left;
    }
    .detailInputRowCenter {
      display: inline-block;
      line-height: 2.2rem;
      flex: 1;
    }

    .detailInputRowCenter2 {
      display: flex;
      flex: 1;
      line-height: 2.5rem;

      .detailInputRowCenter2Item1 {
        display: inline-block;
        text-align: center;

        flex: 1;
      }
      .detailInputRowCenter2Item2 {
        display: inline-block;
        flex: 5;
      }
      .detailInputRowCenter2ItemTerm {
        display: inline-flex;
        flex: 0.5;
      }
    }

    .detailInputRowCenter3 {
      margin-bottom: 0.3rem;
      display: flex;
      flex: 1;
      .detailInputRowCenter2Item1 {
        display: inline-flex;

        flex: 1;
      }
      .detailInputRowCenter2Item2 {
        display: inline-flex;
        flex: 5;
      }
      .detailInputRowCenter2ItemTerm {
        display: inline-flex;
        flex: 1;
      }
    }

    .detailInputRowRight {
      display: inline-block;
      width: 8rem;
    }
  }
}
b-form-spinbutton {
  form-control {
    height: 100%;
  }
}
.item-box {
  background-color: white;
  border: 1px solid #cbcbcb;
  font-size: 0.9rem;
  flex: 5;
  padding: 0rem 0.5rem;
}
.deleteButton {
  display: inline-flex;
  align-items: center;
  height: 2.3rem;
  font-size: 0.8rem;
  width: 100%;
  border: 1px solid #cbcbcb !important;
  background-color: transparent !important;
  padding: 0px !important;
  color: #aa392f;
  border: none;
  outline: none;

  span {
    padding: 0px;
    width: 100%;
    text-align: center;
    padding: 0px !important;
  }
}
.addButton {
  display: inline-flex;
  align-items: center;
  height: 2.3rem;
  font-size: 0.8rem;
  width: 100%;
  background-color: transparent !important;
  border: 1px solid #cbcbcb !important;
  padding: 0px !important;
  color: black;
  border: none;
  outline: none;

  span {
    padding: 0px !important;
    width: 100%;
    text-align: center;
  }
}

.addButton2 {
  display: block;
  margin-top: 0.6rem;
  height: 60%;
  font-size: 0.9rem;
  background-color: #af8c5e !important;
  padding: 0px !important;
  color: white;
  border: none;
  outline: none;

  span {
    padding: 0px;
    width: 100%;
    height: 100%;
    text-align: center;
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }
}

.red {
  color: red;
}

.rentNotice {
  font-size: 0.8rem;
  color: #999999;
  margin-top: 0.5rem;
  p {
    margin-bottom: 0.2rem;
    padding-left: 2em;
    text-indent: -1.3em;
  }
}

.mobile {
  display: none;
}
hr {
  margin-bottom: 0.5rem;
}

.not-required-section {
  margin-top: -0.5rem;
  padding-top: 0.5rem;
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  margin-bottom: -1.5rem;
  padding-bottom: 1.5rem;
  > div {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }
}

@media (max-width: 992px) {
  .outterBox {
    background-color: #fafafa;
    padding: 1rem;
  }

  .web {
    display: none;
  }

  .mobile {
    display: block;
  }

  .headerTitle {
    display: flex;
    flex: 1;
    vertical-align: middle;
    line-height: 2rem;
    .headerText {
      font-size: 1rem;
      font-weight: bold;
    }
    .headerDetailText {
      font-size: 0.8rem;
      color: #999999;
      margin-left: 2rem;
    }
  }

  .headerTitle2 {
    .headerDetailText2 {
      font-size: 0.8rem;
      color: #999999;
    }
  }

  .headerOption2 {
    display: flex;
    vertical-align: middle;
    line-height: 2rem;
    text-align: right;
  }

  .detailInputRowLeft {
    display: inline-block;
    width: 8rem;
    line-height: 2.5rem;
    //height: 2rem;
    text-align: left;
  }
  .detailInputRowCenter2Item1 {
    line-height: 2.5rem;
  }
  .addButton2 {
    display: inline-flex;
    align-items: center;
    vertical-align: middle;

    height: 2.3rem;
    font-size: 0.9rem;
    margin-top: 0rem;
    background-color: #af8c5e !important;
    padding: 0px !important;
    color: white;
    border: none;
    outline: none;

    span {
      padding: 0px;
      width: 100%;
      line-height: 2.3rem;
      text-align: center;
      padding-left: 1rem !important;
      padding-right: 1rem !important;
    }
    &:hover {
      background-color: #af8c5e !important;
      color: white;
    }
  }

  .not-required-section {
    margin-left: -2rem;
    margin-right: -2rem;
    margin-bottom: -2rem;
    padding-bottom: 2rem;
    > div {
      margin-left: 2rem;
      margin-right: 2rem;
    }
  }
}
::v-deep .custom-select {
  font-size: 0.9rem;
}
::v-deep .form-control {
  font-size: 0.9rem;
}
.sms-checkbox {
  ::v-deep .custom-checkbox .custom-control-input ~ .custom-control-label::before {
    border: 1px solid red !important;
  }
  ::v-deep .custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
    border: 1px solid #adb5bd !important;
  }
}
</style>
